var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-field',{attrs:{"name":"scoreSetSelector","items":_vm.scoreSets,"value":_vm.currentScoreSet},on:{"selected":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }